(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4094],{

/***/ 37507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./asset-hyperlink.json": 25994,
	"./blockquote.json": 62559,
	"./document.json": 51734,
	"./embedded-asset-block.json": 1220,
	"./embedded-entry-block.json": 72258,
	"./embedded-entry-inline.json": 92204,
	"./embedded-resource-block.json": 20546,
	"./embedded-resource-inline.json": 8242,
	"./entry-hyperlink.json": 6502,
	"./heading-1.json": 92813,
	"./heading-2.json": 45080,
	"./heading-3.json": 86423,
	"./heading-4.json": 34942,
	"./heading-5.json": 95579,
	"./heading-6.json": 50705,
	"./hr.json": 37121,
	"./hyperlink.json": 13165,
	"./list-item.json": 38094,
	"./ordered-list.json": 28122,
	"./paragraph.json": 38986,
	"./resource-hyperlink.json": 3105,
	"./table-cell.json": 79924,
	"./table-header-cell.json": 91787,
	"./table-row.json": 92884,
	"./table.json": 39269,
	"./text.json": 63022,
	"./unordered-list.json": 58500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37507;

/***/ }),

/***/ 32517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(25877);

var _index = _interopRequireDefault(__webpack_require__(87794));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(50029));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(59499));

var _richTextReactRenderer = __webpack_require__(74129);

var _richTextTypes = __webpack_require__(86437);

var _link = _interopRequireDefault(__webpack_require__(41664));

var _jsxRuntime = __webpack_require__(85893);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var contentful = __webpack_require__(17715);

var client = contentful.createClient({
  space: "q5zz01aouowd",
  accessToken: "9OeBTeBIJs0c3IZYoZrOQWAtMK6aql_tI1gDDmOuXHc"
});

var convertBlogData = function convertBlogData(listEntries) {
  return listEntries.map(function (entry) {
    return _objectSpread({
      id: entry.sys.id
    }, entry.fields);
  });
};

var getAllBlogData = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_index["default"].mark(function _callee() {
    return _index["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", client.getEntries());

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAllBlogData() {
    return _ref.apply(this, arguments);
  };
}();

var getBlogEntryById = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_index["default"].mark(function _callee2(id) {
    return _index["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", client.getEntry(id));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getBlogEntryById(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var createInternalBlogLink = function createInternalBlogLink(post, locale) {
  var sitemap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (sitemap) {
    return "".concat(locale, "/blog/").concat(post.id, "/").concat(post.slug, "/");
  }

  return "/".concat(locale, "/blog/").concat(post.id, "/").concat(post.slug, "/");
};

var renderDataToComponent = function renderDataToComponent(data) {
  var renderOptions = {
    renderNode: (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _richTextTypes.INLINES.EMBEDDED_ENTRY, function (node, children) {
      // target the contentType of the EMBEDDED_ENTRY to display as you need
      if (node.data.target.sys.contentType.sys.id === 'blogPost') {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_link["default"], {
          href: "/blog/".concat(node.data.target.fields.slug),
          children: node.data.target.fields.title
        });
      }
    }), _richTextTypes.BLOCKS.EMBEDDED_ENTRY, function (node, children) {
      // target the contentType of the EMBEDDED_ENTRY to display as you need
      if (node.data.target.sys.contentType.sys.id === 'codeBlock') {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("pre", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("code", {
            children: node.data.target.fields.code
          })
        });
      }

      if (node.data.target.sys.contentType.sys.id === 'videoEmbed') {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("iframe", {
          src: node.data.target.fields.embedUrl,
          height: "100%",
          width: "100%",
          frameBorder: "0",
          scrolling: "no",
          title: node.data.target.fields.title,
          allowFullScreen: true
        });
      }
    }), _richTextTypes.BLOCKS.EMBEDDED_ASSET, function (node, children) {
      // render the EMBEDDED_ASSET as you need
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: "https://".concat(node.data.target.fields.file.url),
        height: node.data.target.fields.file.details.image.height,
        width: node.data.target.fields.file.details.image.width,
        alt: node.data.target.fields.description
      });
    })
  };
  return (0, _richTextReactRenderer.documentToReactComponents)(data, renderOptions);
};

module.exports = {
  convertBlogData: convertBlogData,
  getAllBlogData: getAllBlogData,
  getBlogEntryById: getBlogEntryById,
  createInternalBlogLink: createInternalBlogLink,
  renderDataToComponent: renderDataToComponent
};

/***/ }),

/***/ 48019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/classname/classname.js
var classname = __webpack_require__(80411);
var classname_default = /*#__PURE__*/__webpack_require__.n(classname);
// EXTERNAL MODULE: ./src/components/FooterV2/FooterV2.js
var FooterV2 = __webpack_require__(47327);
// EXTERNAL MODULE: ./src/components/HeaderV2/HeaderV2.js + 1 modules
var HeaderV2 = __webpack_require__(79491);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/pages/api/contentful.js
var contentful = __webpack_require__(32517);
// EXTERNAL MODULE: ./src/components/BlogV2/BlogPostV2.module.css
var BlogPostV2_module = __webpack_require__(36904);
var BlogPostV2_module_default = /*#__PURE__*/__webpack_require__.n(BlogPostV2_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/BlogV2/BlogPostV2.js












var BlogPostV2 = function BlogPostV2(_ref) {
  var data = _ref.data,
      locale = _ref.locale,
      relatedBlogs = _ref.relatedBlogs;

  var _useTranslation = (0,esm/* useTranslation */.$G)('blog'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: "".concat(data.fields.metaTitle, " - Traqqie.com"),
      description: data.fields.metaDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* ArticleJsonLd */.dX, {
      type: "BlogPosting",
      url: "https://traqqie.com/".concat(data.fields.locale, "/blog/").concat(data.sys.id, "/").concat(data.fields.slug, "/"),
      title: data.fields.title,
      datePublished: data.fields.datePublished,
      authorName: data.fields.writtenBy,
      author: [{
        type: 'Organization',
        name: 'Traqqie.com',
        url: 'https://www.traqqie.com/'
      }],
      description: data.fields.shortDescription,
      isAccessibleForFree: true
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "font-inter pt-[72px] md:pt-20 selection:bg-g400",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeaderV2/* default */.Z, {
        locale: locale
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "w-full flex flex-col items-center gap-y-12 py-24 px-6 md:gap-y-24 lg:px-[100px]",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          className: "max-w-[960px] m-0 text-center text-g400 font-semibold text-3xl md:text-5xl md:leading-tight",
          children: data.fields.title
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "max-w-[960px] w-full flex gap-x-16",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-y-3 font-semibold",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-gr600 text-sm",
              children: t('blog_reading_time')
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: "text-gr900 text-lg",
              children: [data.fields.readingTime, " mins"]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-y-3 font-semibold",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: "text-gr600 text-sm",
              children: [' ', t('blog_written_by')]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-gr900 text-lg",
              children: data.fields.writtenBy
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "max-w-[960px] w-full flex flex-col",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: data.fields.previewImage.fields.file.url,
            alt: data.fields.previewImage.fields.title,
            className: "w-full h-auto object-cover"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classname_default()('w-full mt-12 max-w-[720px] mx-auto md:mt-24', (BlogPostV2_module_default()).content),
            children: (0,contentful.renderDataToComponent)(data.fields.content)
          })]
        }), relatedBlogs.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "related-posts-section mt-16 max-w-[960px] w-full",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "text-2xl font-semibold text-g400 mb-8",
            children: t('blog_related_posts')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex flex-wrap gap-6",
            children: relatedBlogs.map(function (blog) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "related-post-card",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "/blog/".concat(blog.sys.id, "/").concat(blog.fields.slug),
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                      className: "text-xl font-semibold",
                      children: blog.fields.title
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: blog.fields.shortDescription
                    })]
                  })
                })
              }, blog.sys.id);
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterV2/* default */.Z, {
        locale: locale
      })]
    })]
  });
};

/* harmony default export */ var BlogV2_BlogPostV2 = (BlogPostV2);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/pages/blog/[...slug].js





var BlogPostPage = function BlogPostPage(_ref) {
  var locale = _ref.locale,
      data = _ref.data,
      relatedBlogs = _ref.relatedBlogs;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BlogV2_BlogPostV2, {
      data: data,
      locale: locale,
      relatedBlogs: relatedBlogs
    })
  });
};

var __N_SSP = true;
/* harmony default export */ var _slug_ = (BlogPostPage);

/***/ }),

/***/ 55706:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[...slug]",
      function () {
        return __webpack_require__(48019);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36904:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"BlogPostV2_content__zV197"};

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1522,2962,4577,9591,6927,9774,2888,179], function() { return __webpack_exec__(55706); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);